module.exports = __webpack_public_path__ + "static/media/prytula.7f3cf9db.jpg";